<template>
	<a-layout id="components-layout-demo-fixed">
		<Header
			style="height: 8vh;background-color: #7FB7ED;color: white;display: flex;flex-direction: row;justify-content: space-between;align-items: center;">
			<div style="font-size: 22px;margin-left: 20px;">高新区知识产权运营服务平台</div>
			<a-dropdown style="margin-right: 20px;">
				<a class="ant-dropdown-link" @click="e => e.preventDefault()" style="color: #444444;">
					{{this.$store.state.user}}
					<a-icon type="down" />
				</a>
        <a-menu slot="overlay">
          <a-menu-item>
            <a href="javascript:;" @click="logout()">
              <a-icon type="logout" />
              注销登录
            </a>
          </a-menu-item>
        </a-menu>
			</a-dropdown>
		</Header>
		<a-layout id="components-layout-demo-custom-trigger">
			<a-layout-sider width="300" style="background: #fff" v-model="collapsed" :trigger="null" collapsible>
				<a-menu mode="inline" :default-selected-keys="['1']" :default-open-keys="['sub1']"
					:style="{ height: '100%', borderRight: 0}">
					<a-menu-item key="1">
						<router-link to="/into">
							<a-icon type="search" />
							商标查询
						</router-link>

					</a-menu-item>
					<a-sub-menu key="2">
						<span slot="title">
							<a-icon type="user" />商标数据分析
						</span>

						<a-menu-item v-for="item in pdfMenus" :key="2-item.id" >
							<router-link to="/pdf" @click.native="change(item.rangeList)">{{item.name}}</router-link>
						</a-menu-item>
					</a-sub-menu>


				</a-menu>
			</a-layout-sider>
			<a-layout>


				<a-layout-content :style="{ padding: '0 25px', marginTop: '30px'}">
					<div :style="{ background: '#fff', padding: '24px', minHeight: '380px' }">
						<router-view></router-view>
					</div>
				</a-layout-content>
			</a-layout>

		</a-layout>

	</a-layout>
</template>
<script>
	import axios from 'axios'

  export default {
		data() {
			return {
				collapsed: false,
				nickname: '',
				selectedKeys: ['1-1'],
				openKeys: ['1'],
        pdfMenus:[]
			}
		},
		methods: {
			logout() {
				// var user = {

				// }
				// user = JSON.parse(localStorage.getItem('local')).user
				localStorage.clear();
				// localStorage.setItem('local', JSON.stringify(user))
				this.$router.push('/');
			},
			change(range) {
				this.$store.commit('changePage', range);
			},
      getPdfPages(){
        axios.get('http://39.107.241.80:8081/guoweiBrand/brand/queryPdf',  {
          headers: {
            'token': JSON.parse(localStorage.getItem('local'))
          }
        }).then(res => {
          let pdfData = res.data.data;
          this.pdfMenus = pdfData;
        }).catch((error) => {
          console.log(error);
          this.$message.error("获取文件失败")
        })
      }
		},
		mounted() {
			// console.log(this.nickname.nickname)
			this.nickname = this.$route.query.user;
      this.getPdfPages();
		}
	}
</script>
<style>
	#components-layout-demo-custom-trigger .trigger {
		font-size: 18px;
		line-height: 64px;
		padding: 0 24px;
		cursor: pointer;
		transition: color 0.3s;
	}

	#components-layout-demo-custom-trigger .trigger:hover {
		color: #1890ff;
	}

	#components-layout-demo-custom-trigger .logo {
		height: 32px;
		background: rgba(255, 255, 255, 0.2);
		margin: 16px;
	}

	#components-layout-demo-fixed {
		height: 100vh;
	}
</style>
